import {Component} from '@angular/core';

export interface VolmachtGrantee {
  name: string;
  involvedPartyCode: string;
  siebelId: string;
}

@Component({
  selector: 'app-detail-table',
  templateUrl: './volmacht-grantees-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})

export class VolmachtGranteesTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: VolmachtGrantee[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }

  public formUrl(customerType: string, siebelId: string) {
    if(customerType === 'Natuurlijk persoon')
    {
      window.open('https://siebel.rabobank.nl/fins_nld/redirectService.htm?ViewName=CustomerHouseholdSummary&MapParam1=' + siebelId, '_self');
    }
    else if(customerType === 'Organisatie') {
      window.open('https://siebel.rabobank.nl/fins_nld/redirectService.htm?ViewName=CustomerAccountSummary&MapParam1=' + siebelId, '_self');
    }
  }
}
